function main() {
  const needResourceList = [];

  if (needResourceList.filter(Boolean).length !== needResourceList.length)
    return setTimeout(main, 240);

  $(function () {
    $("#root").css("zoom", "normal");
    let scale = document.body.clientWidth / 1080;
    $("#root").css("zoom", scale);

    window.addEventListener(
      "resize",
      (function () {
        var timer;
        return function () {
          if (timer) clearTimeout(timer);
          timer = setTimeout(function () {
            $("#root").css("zoom", "normal");
            let scale = document.body.clientWidth / 1080;
            $("#root").css("zoom", scale);
          }, 100);
        };
      })()
    );
  });

  $(".buyNow").click(function () {
    const targetElement = document.getElementById("product-buy"); // 获取跳转目标节点
    const offsetTop = targetElement.offsetTop + 8;
    window.scroll({
      top: offsetTop * $("div#root").css("zoom"),
      behavior: "smooth", // 使用 smooth 实现平滑滚动
    });
  });

  var swiper = new Swiper(".mySwiper", {
    autoplay: {
      delay: 2000,
      stopOnLastSlide: false,
      disableOnInteraction: false,
    },
    loop: true, //循环滚动
    on: {
      click: function (e) {
        if (swiper.realIndex == 0) {
          var element = document.getElementById("product-buy");
          var height = $("header").height();
          var topOffset = element.offsetTop - height;
          $("html,body").animate(
            {
              scrollTop: topOffset * $("#root").css("zoom") + "px",
            },
            300
          );
        }
      },
    },
  });
  var swiper1 = new Swiper(".mySwiper3", {
    slidesPerView: 1,
    autoplay: {
      delay: 4000,
      stopOnLastSlide: false,
      disableOnInteraction: false,
    },
    loop: true, //循环滚动
    navigation: {
      nextEl: ".sp-swiper1 .swiper-button-next",
      prevEl: ".sp-swiper1 .swiper-button-prev",
    },
  });
  var swiper2 = new Swiper(".mySwiper2", {
    slidesPerView: 4,
    spaceBetween: 57,
    centeredSlides: true,
    loop: true, //循环滚动
    freeMode: true,
    speed: 6500, //匀速时间
    autoplay: {
      delay: 0,
      stopOnLastSlide: false,
      disableOnInteraction: false,
    },
  });
  let prods = window.products.variants;
  // 初始化
  alignmentFns.initialize();
  $("#2").change(function () {
    var number = Number($("#2").val());
    $(this)
      .parents()
      .siblings(".sp-price")
      .children()
      .children(".new")
      .html(((number * Number(prods[0].price)) / 100).toFixed(2));
    $(this)
      .parents()
      .siblings(".sp-price")
      .children()
      .children(".old")
      .html(((number * Number(prods[0].compare_at_price)) / 100).toFixed(2));
    $(this)
      .parents()
      .siblings(".sp-texts")
      .children(".save-text")
      .html(
        (
          (number * Number(prods[0].compare_at_price - prods[0].price)) /
          100
        ).toFixed(2)
      );
  });
  $("#3").change(function () {
    var number = Number($("#3").val());
    $(this)
      .parents()
      .siblings(".sp-price")
      .children()
      .children(".new")
      .html(((number * Number(prods[1].price)) / 100).toFixed(2));
    $(this)
      .parents()
      .siblings(".sp-price")
      .children()
      .children(".old")
      .html(((number * Number(prods[1].compare_at_price)) / 100).toFixed(2));
    $(this)
      .parents()
      .siblings(".sp-texts")
      .children(".save-text")
      .html(
        (
          (number * Number(prods[1].compare_at_price - prods[1].price)) /
          100
        ).toFixed(2)
      );
  });
  $("#4").change(function () {
    var number = Number($("#4").val());
    $(this)
      .parents()
      .siblings(".sp-price")
      .children()
      .children(".new")
      .html(((number * Number(prods[2].price)) / 100).toFixed(2));
    $(this)
      .parents()
      .siblings(".sp-price")
      .children()
      .children(".old")
      .html(((number * Number(prods[2].compare_at_price)) / 100).toFixed(2));
    $(this)
      .parents()
      .siblings(".sp-texts")
      .children(".save-text")
      .html(
        (
          (number * Number(prods[2].compare_at_price - prods[2].price)) /
          100
        ).toFixed(2)
      );
  });
  $("#5").change(function () {
    var number = Number($("#5").val());
    $(this)
      .parents()
      .siblings(".sp-price")
      .children()
      .children(".new")
      .html(((number * Number(prods[3].price)) / 100).toFixed(2));
    $(this)
      .parents()
      .siblings(".sp-price")
      .children()
      .children(".old")
      .html(((number * Number(prods[3].compare_at_price)) / 100).toFixed(2));
    $(this)
      .parents()
      .siblings(".sp-texts")
      .children(".save-text")
      .html(
        (
          (number * Number(prods[3].compare_at_price - prods[3].price)) /
          100
        ).toFixed(2)
      );
  });
  $(document).scroll(function (e) {
    var beforScrollTop = $(document).scrollTop();
    setTimeout(function () {
      $("header").addClass("stiky");
    }, 50);
  });
  // 倒计时的事件
  // 当前时间
  TimeDown(43200000);
  /*
         时间倒计时
         TimeDown.js
         */
  function TimeDown(value) {
    //倒计时的总秒数
    var totalSeconds = parseInt(value / 1000);
    //取模（余数）
    var modulo = totalSeconds % (60 * 60 * 24);
    //小时数
    var hours = Math.floor(modulo / (60 * 60));
    modulo = modulo % (60 * 60);
    //分钟
    var minutes = Math.floor(modulo / 60);
    //秒
    var seconds = modulo % 60;

    hours = hours.toString().length == 1 ? "0" + hours : hours;
    minutes = minutes.toString().length == 1 ? "0" + minutes : minutes;
    seconds = seconds.toString().length == 1 ? "0" + seconds : seconds;

    //输出到页面
    $(".hours").html(hours);
    $(".minutes").html(minutes);
    $(".seconds").html(seconds);
    //延迟一秒执行自己
    if (hours == "00" && minutes == "00" && parseInt(seconds) - 1 < 0) {
    } else {
      setTimeout(function () {
        TimeDown(value - 1000);
      }, 1000);
    }
  }

  $(".link-btn").click(function () {
    let id = $(this).attr("data-id");
    let num = $(this).siblings(".sp-number").find("input").val();
    window.location.href = "/cart/" + id + ":" + num;

    // var items = [{
    //     quantity: num, // 数量
    //     variant_id: id, // 子商品id
    //     note: '', // 备注
    // }]
    // $.post('/api/checkout/order', {
    //     line_items: items,
    //     refer_info: { source: 'buy_now' }
    // }, function (ret) {
    //     if (ret.state === 'success') {
    //         return (window.safeHref = '/checkout/' + ret.data.order_token + '?step=contact_information');
    //     } else {
    //         $.toast.show({
    //             content:
    //                 {
    //                     '30003': "Some items have been removed, please re-order",
    //                     'line_items_variant_withdraw': "Some items have been sold out, please re-order",
    //                     'line_items_variant_sold_out': "Some items are not in stock, please re-order"
    //                 }[ret.state] || ret.errors[0] || "Some items information has been updated, please re-order"
    //         });
    //     }
    // });
  });
}

main();
